import React, { useState } from 'react'
import TagCustom from '../ServicesDemand/tag'
import {
  useDisclosure,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogBody,
  AlertDialogFooter,
  Button,
  useToast,
} from '@chakra-ui/react'
import { useDispatch } from 'react-redux'
import { removeUser } from '../../../../commons/redux/actions/user.actions'
export default function Item({ name, tel, email, district, town, _id }) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const cancelRef = React.useRef()
  const toast = useToast()
  const [load, setLoad] = useState(false)

  const dispatch = useDispatch()
  const remove = async () => {
    try {
      setLoad(true)
      const { message } = await dispatch(removeUser(_id))
      onClose()
      if (message === 'removed') {
        toast({
          title: 'Reussite.',
          description: 'Suppression reussite.',
          status: 'success',
          duration: 9000,
          isClosable: true,
        })
      }
      setLoad(false)
    } catch (error) {}
  }
  return (
    <div>
      <div className=" border user_itembis p-2   my-3 flex-col">
        <h3 className="text-center font-bold text-sm text-green-500">
          Details du profil
        </h3>

        <div className="flex p-2 flex-wra justify-content-center text-center align-item-center align-content-center">
          <div className="text-xs text-muted p-2 w-50">
            <TagCustom size={'md'} price="Personnalite" colorScheme="blue" />
            <div className="flex-col my-1">
              <h6>Nom :</h6>
              <p className="font-bold text-black">{name}</p>
            </div>
            <div className="flex-col my-1 ">
              <h6>Tel :</h6>
              <p className="font-bold text-black">{tel}</p>
            </div>
            <div className="flex-col  my-1 ">
              <h6>Email :</h6>
              <p className="font-bold text-black">{email}</p>
            </div>{' '}
          </div>{' '}
          <div className="text-xs text-muted p-2 w-50 pt-2">
            <TagCustom size={'md'} price="Adresse" colorScheme="cyan" />
            <h6 className="mt-1">Ville :</h6>
            <p className="font-bold text-black">{town}</p>
            <h6>Quartier :</h6>
            <p className="font-bold text-black">{district} </p>
          </div>
        </div>
        <div className="flex text-xs justify-content-right align-items-center">
          <h3 className="text-black font-bold">CodeID :</h3>
          <p>123cf</p>
        </div>
        <div className="flex gap-2 mx-auto justify-content-center">
          <button className="btn btn-light font-bold bg-gray-200 text-sm btn-sm">
            Modifier
          </button>
          <button
            onClick={onOpen}
            className="btn btn-danger font-bold bg-red0 text-white text-sm btn-sm"
          >
            Supprimer
          </button>
        </div>
        <AlertDialog
          motionPreset="slideInBottom"
          leastDestructiveRef={cancelRef}
          onClose={onClose}
          isOpen={isOpen}
          isCentered
        >
          <AlertDialogOverlay>
            <AlertDialogContent>
              <AlertDialogHeader fontSize="lg">
                Supprimer <h3 className="text-red-500">{name}</h3>
              </AlertDialogHeader>

              <AlertDialogBody>
                Etes ous sur? Vous ne pourrez plus recuperer cet utilisateur
                apres supression
              </AlertDialogBody>

              <div className="flex gap-3 mx-auto my-2">
                <Button
                  color={'InfoText'}
                  colorScheme={'green'}
                  ref={cancelRef}
                  onClick={onClose}
                >
                  Annuler{' '}
                </Button>
                {load ? (
                  <Button
                    variant={'solid'}
                    colorScheme="orange"
                    loadingText="Annulation..."
                    isLoading
                    ml={3}
                  ></Button>
                ) : (
                  <Button
                    variant={'solid'}
                    colorScheme="red"
                    onClick={remove}
                    ml={3}
                  >
                    Supprimer{' '}
                  </Button>
                )}
              </div>
            </AlertDialogContent>
          </AlertDialogOverlay>
        </AlertDialog>
      </div>
    </div>
  )
}
